var OrganizationShuttleSelectPopover;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import OrganizationHierarchicalList from 'trunks/vue/admin/compositions/organizations_sidebar/organization_navigator_list/organization_hierarchical_list.js';

export default OrganizationShuttleSelectPopover = Vue.extend({
  components: {
    'Popover': Popover,
    'organization-hierarchical-list': OrganizationHierarchicalList
  },
  template: `<Popover position="bottom center" customClass='shuttle-list-popover popover-default'>
  <template slot="trigger">
    <div>
      <span>{{ popoverDisplayValue }}</span>
      <i class="slp-chevron-down"></i>
    </div>
  </template>
  <template slot="content">
    <div class="groups">
      <div class="list-group">
        <div class="list">
          <div class="list-item"
              :class='membersClass'
              @click="selectMembers">
            <i class="slp-users-o"></i>
            <span>所有成员</span>
          </div>
          <div class="list-item"
              :class='suspendedMembersClass'
              @click="selectSuspendedMembers">
            <i class="slp-users-times-o"></i>
            <span>未在组织成员</span>
          </div>
        </div>
      </div>
      <organization-hierarchical-list
        :resources='"/admin/organizations"'
        :initialSelectedNodeId='initialSelectedNodeId'
        :readonly='false'
        @organizationSelected='updateSelectedOrganization'
        ref='organizationsSelect' />
    </div>
  </template>
</Popover>`,
  data: function() {
    return {
      selectedOrganizationId: 'members'
    };
  },
  watch: {
    selectedOrganizationId: function() {
      return this.$emit('updateSelectedOrganizationId', this.selectedOrganizationId);
    }
  },
  computed: {
    initialSelectedNodeId: function() {
      if (!_.contains(['members', 'suspended_members'], this.selectedOrganizationId)) {
        return this.selectedOrganizationId;
      }
    },
    popoverDisplayValue: function() {
      switch (this.selectedOrganizationId) {
        case 'members':
          return "所有成员";
        case 'suspended_members':
          return "未在组织成员";
        default:
          return this.selectedOrganizationName;
      }
    },
    membersClass: function() {
      return {
        selected: this.selectedOrganizationId === 'members'
      };
    },
    suspendedMembersClass: function() {
      return {
        selected: this.selectedOrganizationId === 'suspended_members'
      };
    }
  },
  methods: {
    selectMembers: function() {
      return this.selectedOrganizationId = 'members';
    },
    selectSuspendedMembers: function() {
      return this.selectedOrganizationId = 'suspended_members';
    },
    updateSelectedOrganization: function(organization) {
      this.selectedOrganizationId = organization.id;
      return this.selectedOrganizationName = organization.name;
    }
  }
});
